import { Container, Grid, Typography, Box } from '@mui/material';
import React from 'react';
// import { useEffect } from 'react';
// import { useState } from 'react';

import Project from './Project/Project';
import './Projects.css';

import projects from '../../../data/projects_data.json';

const Projects = () => {
  return (
    <Box sx={{ bgcolor: 'aliceblue' }}>
      <Container
        sx={{
          py: 7,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center'
        }}
      >
        <Typography variant="h3" sx={{ fontWeight: 'bold' }}>
          My Latest Projects
        </Typography>
        <Typography variant="body1" sx={{ mt: 3 }}>
          You are welcome to visit the detail page of these projects to check
          Live Demo as well as Code Repository.
        </Typography>
        <Box sx={{ mt: 5 }}>
          <Grid container spacing={3}>
            {projects.map((project) => (
              <Project key={project.id} project={project}></Project>
            ))}
          </Grid>
        </Box>
      </Container>
    </Box>
  );
};

export default Projects;
